export default __webpack_public_path__ + "static/media/registro_instrucciones.a9c878da.png";